import { computed, ref } from 'vue';

export const useLoading = () => {
  const _loader = ref(false);

  const showLoader = () => {
    _loader.value = true;
  };

  const hideLoader = () => {
    _loader.value = false;
  };

  const loading = computed(() => _loader.value);

  return {
    loading,
    showLoader,
    hideLoader,
  };
};
